import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAutoCorrect: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="auto-correct,autocheck, text-correction"><path d="M2.75 19.25L10.0447 2.75L15.06 14.0938H5.3553" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M13.75 18.75L16.25 21.25L21.25 13.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconAutoCorrect;
